import { _axios } from '../plugins/axios'
import { globals } from '../main.js'
import Configuration from '@/configuration'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, log it and let the caller decide what to do
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export default {
  async getNewMoc(communityAbbrev) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetNewMoc/${communityAbbrev}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async close(mocid) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/Close/${mocid}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async save(data, advanceType) {
    //first get the communityAbbrev before trimming
    let communityAbbreviation = data.communityData.communityAbbreviation

    // let make the upload a bit smaller and remove some unnecessary stuff
    // delete data['communityData']
    // data.communityData = {}
    // data.communityData.communityAbbreviation = communityAbbreviation

    return new Promise((resolve, reject) => {
      if (
        data.roles.facilitator &&
        data.roles.facilitatorBackup &&
        data.roles.facilitator.id &&
        data.roles.facilitator.id === data.roles.facilitatorBackup.id
      ) {
        reject('Facilitator cannot be the same as backup facilitator')
        return
      }
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: { Moc: data, AdvanceType: { Value: advanceType } },
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/Save/${communityAbbreviation}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async saveAndContinue(data, advanceType) {
    return new Promise((resolve, reject) => {
      if (
        data.roles.facilitator &&
        data.roles.facilitatorBackup &&
        data.roles.facilitator.id &&
        data.roles.facilitator.id === data.roles.facilitatorBackup.id
      ) {
        reject('Facilitator cannot be the same as backup facilitator')
        return
      }
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: { Moc: data, AdvanceType: { Value: advanceType } },
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/SaveAndContinue/${data.communityData.communityAbbreviation}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getAllMocs(communityAbbrev) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/Get/${communityAbbrev}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getMocCount(communityAbbrev) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetMocCount/${communityAbbrev}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getMocById(communityAbbrev, mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetMoc/${communityAbbrev}/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getMocSupportingLinks(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('docsEndPoint').concat(`/api/SupportingLinks/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getMocSupportingDocs(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/List?mocId=${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async uploadSupportingDoc(mocId, file, cancelToken) {
    let data = new FormData()

    data.append(`Comment`, file.comments || '')
    // omitted when the user made no choice so the service can leave it unanswered
    if (file.uploadToOpenText === true || file.uploadToOpenText === false) {
      data.append(`UploadToOpenText`, file.uploadToOpenText)
    }
    data.append(`mocId`, mocId)
    data.append(`mimeType`, file.type)
    data.append(`fileName`, file.name)

    // send it out to our services
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/${mocId}`),
          data: data,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data'
          },
          cancelToken: cancelToken
        })
          .then((success) => {
            resolve({
              fileName: file.name,
              data: success.data
            })
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async updateSupportingDocComment(mocId, file, versionId) {
    let data = new FormData()

    data.append(`Comment`, file.comments || '')
    // omitted when the user made no choice so the service keeps the stored value
    if (file.uploadToOpenText === true || file.uploadToOpenText === false) {
      data.append(`UploadToOpenText`, file.uploadToOpenText)
    }
    data.append(`mocId`, mocId)
    data.append(`mimeType`, file.type || file.mimeType || '')
    data.append(`fileName`, file.fileName)

    // send it out to our services
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/UpdateComment/${versionId}`),
          data: data,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((success) => {
            resolve({
              fileName: file.name,
              data: success.data
            })
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async uploadSupportingLink(mocId, link, comment, title, id) {
    let data = new FormData()
    data.append('Comment', comment)
    data.append('mocId', mocId)
    data.append('link', link)
    data.append('title', title)
    if (id !== undefined) data.append('id', id)

    // send it out to our services
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('docsEndPoint').concat(`/api/SupportingLinks/${mocId}`),
          data: data,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async downloadSupportingDoc(mocId, fileName, version) {
    let url = Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/${mocId}?fileName=${fileName}`)
    if (version !== undefined) url.concat(`&version=${version}`)

    // do this to get the api key to the server...
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: url,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          responseType: 'blob'
        })
          .then((success) => {
            // craft our linky link here.
            const downloadUrl = window.URL.createObjectURL(new Blob([success.data]))
            const link = document.createElement('a')
            link.href = downloadUrl
            link.setAttribute('download', fileName)
            link.setAttribute('target', '_blank')
            link.click()
            window.URL.revokeObjectURL(downloadUrl)
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async deleteSupportingDoc(mocId, fileName) {
    let url = Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/${mocId}?fileName=${fileName}`)

    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'delete',
          url: url,
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async deleteSupportingLink(mocId, id) {
    let url = Configuration.value('docsEndPoint').concat(`/api/SupportingLinks/${mocId}?id=${id}`)

    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'delete',
          url: url,
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  findUserInActiveMocs(communityAbbrev, userId, inRoles, skipMultiplier) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/FindUserInActiveMocs/${communityAbbrev}/${userId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params: { inRoles, skipMultiplier }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  replaceUserInMOCs(communityAbbrev, data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data,
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/ReplaceUserInMOCs/${communityAbbrev}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getUserReplacementByReference(communityAbbreviation, reference) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(
            `/api/Moc/GetUserReplacementByReference/${communityAbbreviation}/${reference}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getMocStatus(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetMocStatus/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getMocVersionFile(communityAbbreviation, mocId, version) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetMocVersion/${communityAbbreviation}/${mocId}/${version}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  remindNonRespondersApprovers(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/RemindNonRespondersApprovers/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  isEnableReminderToNonRespondersApprovers(mocId, currentPass = 0) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(
            `/api/Moc/IsEnableReminderToNonRespondersApprovers/${mocId}/${currentPass}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  search(query, page, limit, communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/search`),
          params: { query, page, limit, communityAbbreviation },
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getArchive(mocId, cancelToken, onDownloadProgress) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/getarchive/${mocId}`),
          onDownloadProgress,
          onUploadProgress: onDownloadProgress,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          cancelToken
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getEmoc1Archive(mocId, cancelToken) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/getemoc1archive/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: 'application/zip'
          },
          responseType: 'blob',
          cancelToken
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  notifyTaskAssignment(mocId, task) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/notifytaskassignment/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: task
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getMOCDashboardCount(communityAbbrev, selectedCategory) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/getmocdashboardcount/${communityAbbrev}/${selectedCategory}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getPaginatedMOCDashboard(communityAbbrev, selectedCategory, params, cancelToken) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetPaginatedDashboard/${communityAbbrev}/${selectedCategory}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params,
          cancelToken
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getNotificationLogs(mocId, key, status, isTag, isReminder, params) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/getNotificationLogs/${mocId}/${key}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params: {
            isTag,
            isReminder,
            status,
            ...params
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getNotifications(mocId, key, status, isTag, isReminder) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetParsedEmailTemplate/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params: {
            isTag,
            isReminder,
            status,
            key
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getEmailVariables(mocId, params) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/GetEmailVariablesForMoc/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getArchiveStatus(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/getarchivestatus/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  requestArchive(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          url: Configuration.value('uiEndPoint').concat(`/api/Moc/requestarchive/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  }
}
